import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=3ccdb912&"
import script from "./Modal.vue?vue&type=script&lang=js&"
export * from "./Modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ccdb912')) {
      api.createRecord('3ccdb912', component.options)
    } else {
      api.reload('3ccdb912', component.options)
    }
    module.hot.accept("./Modal.vue?vue&type=template&id=3ccdb912&", function () {
      api.rerender('3ccdb912', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwg/js/components/Modal.vue"
export default component.exports